import { InvoiceStatus, OrderStatus } from "../enums";

export function getDeleteInvoiceDisabled(
  invoiceStatus: string | undefined,
  orderStatus: OrderStatus | undefined,
): boolean {
  const blockedByOrder =
    orderStatus === OrderStatus.DISPATCHED ||
    orderStatus === OrderStatus.DELIVERED;
  const invoiceOk = invoiceStatus === InvoiceStatus.UNPAID;
  return blockedByOrder || !invoiceOk;
}

export function getDeleteInvoiceTooltip(
  invoiceStatus: string | undefined,
  orderStatus: OrderStatus | undefined,
): string {
  if (orderStatus === OrderStatus.DISPATCHED) {
    return "Cannot delete: order has been dispatched";
  }
  if (orderStatus === OrderStatus.DELIVERED) {
    return "Cannot delete: order has been delivered";
  }
  if (invoiceStatus === InvoiceStatus.PAID) {
    return "Cannot delete: invoice is paid";
  }
  if (invoiceStatus === InvoiceStatus.RECEIVED) {
    return "Cannot delete: invoice is received";
  }
  if (invoiceStatus !== InvoiceStatus.UNPAID) {
    return "Cannot delete: only unpaid invoices can be removed";
  }
  return "Delete invoice";
}
